import { Number } from './number.component';

/**
 * Used to emit changes performed on number input components.
 */
export class NumberChange {
  /**
   * Contains the `Number` that has been changed.
   */
  // tslint:disable-next-line: ban-types
  source: Number;
  /**
   * The value of the `Number` field encompassed in the `NumberChange` class.
   */
  value: number;
}
